export const CLIENT_MESSAGE_TYPES = {
  JOIN: "join",
  INPUT: "input",
  PROJECTILE_SPAWN: "projectile_spawn",
  HEAL: "heal",
  CHAT_MESSAGE: "chat_message",
  SCORE_EVENT: "score_event",
  BULLETIN_BOARD_CREATE: "bulletin_board_create",
  BULLETIN_BOARD_UPDATE: "bulletin_board_update",
  BULLETIN_BOARD_DELETE: "bulletin_board_delete",
  PING: "ping",
};

export const SERVER_MESSAGE_TYPES = {
  ERROR: "error",
  WELCOME: "welcome",
  STATE: "state",
  PLAYER_JOINED: "player_joined",
  PLAYER_LEFT: "player_left",
  PROJECTILE_SPAWN: "projectile_spawn",
  PROJECTILE_HIT: "projectile_hit",
  COMBAT_HIT: "combat_hit",
  COMBAT_SWING: "combat_swing",
  CHAT_MESSAGE: "chat_message",
  BULLETIN_BOARD_SNAPSHOT: "bulletin_board_snapshot",
  PONG: "pong",
};

export const COMBAT_SWING_RESULT = {
  START: "start",
  HIT: "hit",
  MISS: "miss",
};

export const ERROR_CODES = {
  BAD_JSON: "bad_json",
  BAD_TYPE: "bad_type",
  PAYLOAD_TOO_LARGE: "payload_too_large",
  RATE_LIMITED: "rate_limited",
  ROOM_FULL: "room_full",
  NOT_JOINED: "not_joined",
  MESSAGE_REJECTED: "message_rejected",
  SCORE_EVENT_REJECTED: "score_event_rejected",
};

export const COMBAT_MODE = {
  PVP: "pvp",
  ENEMY: "enemy",
};
